import React, { Component } from 'react';
import {
  faPython,
  faAws,
  faJava,
  faJsSquare,
  faNodeJs,
  faReact,
  faApple,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Resume extends Component {
  render() {
    return (
      <React.Fragment>
    {/* Resume Section
    ================================================== */}
      <section id="resume">
        {/* Education
      ----------------------------------------------- */}
        <div className="row education">
          <div className="three columns header-col">
            <h1><span>Education</span></h1>
            <img src="images/nus.png" alt />
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>National University Singapore</h3>
                <p className="info">Computer Engineering (CEG)<span>•</span> <em className="date">Aug 2017 - Present</em></p>
                <p style={{textAlign:'left'}}>
                  The Computer Engineering programme (CEG) at NUS prepares its graduates to embark on a lifelong journey in designing computing systems for a smarter world.
                </p>
                <p style={{textAlign:'left'}}>
                  Computer engineering is a field which emphasises both hardware and software. Through my semesters in this course, I have learnt the importance of integration between the two. Although all of us will eventually specialise in a field of computing (i.e Machine Learning or AI) we will never forget the fun we had while building tiny robots and having them navigate autonomously thru a secret maze. <br/> <br/>
                  Module highlights:<br/>
                  1. <strong>Programming methodology</strong><br/>
                  2. <strong>Data structures and algorithms</strong><br/>
                  3. <strong>Independent software engineering project</strong><br/>
                  4. <strong>Information retrieval</strong> - Query handling and postings generation for search engines<br/>
                  5. <strong>Design and analysis of algorithms</strong> - Analyse time complexities and learn about various algorithms. <br/>
                  6. <strong>Engineering principles and practices</strong> - Maze navigating robot, capable of simultaneous localisation and mapping
                </p>
              </div>
            </div> {/* item end */}
          </div> {/* main-col end */}
        </div> {/* End Education */}
        {/* Work
      ----------------------------------------------- */}
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Bumblebee Autonomous Systems</h3>
                <img src="images/bumblebee.JPG" alt />

                <p className="info">Software Engineer <span>•</span> <em className="date">Sep 2017 - Present</em></p>
                <a href="http://bumblebee.sg/"> http://bumblebee.sg/ </a>
                <p style={{textAlign:'left'}}>
                Bumblebee Autonomous Systems strive to develop Autonomous systems for maritime use. The organisation is developing on Autonomous Underwater Systems and Surface Vessels. We placed <strong>1st</strong> for RobotX 2018 and <strong>2nd</strong> for Robosub 2018 <br />
                 <br/>
                I've worked with vision related tasks such as object identification and tracking for Robosub 2018 and RobotX 2018 <nr/>
                </p>
              </div>
            </div> {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>National University of Singapore, School of Computing</h3>
                <p className="info">Teaching Assistant <span>•</span> <em className="date">Jan 2019 - May 2019</em></p>
                <p style={{textAlign:'left'}}>
                Teaching assistant for CS2040C (Data structures and algorithm). Working under Dr. Steven Halim, responsibilities include:<br />
                1. Teaching and conducting lab sessions<br />
                2. Marking code submissions<br />
                3. Consultation with students<br />
                </p>
              </div>
            </div> {/* item end */}
          </div> {/* main-col end */}
        </div> {/* End Work */}

        {/* Awards
      ----------------------------------------------- */}
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Awards</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Defence Science and Technology (DSTA) Merit Scholarship</h3>

                <p className="info"><em className="date">Dec 2018 - Present</em></p>
                <p style={{textAlign:'left'}}>
                The Defence Science and Technology Agency (DSTA) is a statutory board under the Ministry of Defence of the Singapore Government. DSTA is responsible for performing acquisitions management, systems management, systems development for the Singapore Ministry of Defence and the Singapore Armed Forces.
                </p>
              </div>
            </div> {/* item end */}
          </div> {/* main-col end */}
        </div> {/* End Awards */}
      
      {/* Publications
      ----------------------------------------------- */}
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Publication</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Robosub journal paper</h3>
                <p className="info"><em className="date">Jul 2018</em></p>
                <p>Robosub was an exciting underwater robotics competition hosted by Robonation. Teams of high school and college students from around the world design build Autonomous Underwater Vehicles (AUV) to compete. These vehicles were designed to autonomously navigate through a series of tasks. This journal details the design aspects for our autonomous vehicle.<br/>
                <a href="https://www.robonation.org/sites/default/files/NatlUSingaporeBumblebee_TDR_RS18.compressed.pdf">see here</a></p>
              </div>
            </div> {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>RobotX journal paper</h3>
                <p className="info"><em className="date">Dec 2018</em></p>
                <p>Similar to Robosub, this event was hosted by Robonation and it involves designing a competition surface vessel which could navigate open waters and perform tasks. This journal details the design aspects for our autonomous surface vessel.<br/>
                <a href="resources/RobotXJournal2018.pdf">see here</a></p>
              </div>
            </div> {/* item end */}

          </div> {/* main-col end */}
        </div> {/* End Publications */}

        {/* Skills
      ----------------------------------------------- */}
        <div className="row skill">
          <div className="three columns header-col">
            <h1><span>Languages</span></h1>
          </div>
          <div className="nine columns main-col">
            <p>These are rough indicators of my proficiency in the various programming languages.
            </p>
            <div className="bars">
              <ul className="skills">
                <li><span className="bar-expand full" /><em>C++ <div class="icon baseline"><img src="images/c++.svg"/></div></em></li>
                <li><span className="bar-expand full" /><em>Python <FontAwesomeIcon icon={faPython} /></em></li>
                <li><span className="bar-expand fifty" /><em>Swift <div class="icon baseline"><img src="images/swift.svg"/></div></em></li>
                <li><span className="bar-expand fifty" /><em>Java <FontAwesomeIcon icon={faJava} /></em></li>
                <li><span className="bar-expand twentyfive" /><em>Javascript <FontAwesomeIcon icon={faJsSquare} /></em></li>
              </ul>
            </div>{/* end skill-bars */}
          </div> {/* main-col end */}
        </div> {/* End skills */}

        <div className="row skill">
          <div className="three columns header-col">
            <h1><span>Tools</span></h1>
          </div>
          <div className="nine columns main-col">
            <p>These are rough indicators of my proficiency with the various tools, libraries, frameworks and platforms
            </p>
            <div className="bars">
              <ul className="skills">
                <li><span className="bar-expand full" /><em>ROS (Robotics operating system) <div class="icon baseline"><img src="images/ros.svg"/></div></em></li>
                <li><span className="bar-expand full" /><em>OpenCV <div class="icon baseline"><img src="images/opencv.svg"/></div></em></li>
                <li><span className="bar-expand seventyfive" /><em>iOS <FontAwesomeIcon icon={faApple} /></em></li>
                <li><span className="bar-expand fifty" /><em>AWS (Amazon Web Services) <FontAwesomeIcon icon={faAws} /></em></li>
                <li><span className="bar-expand twentyfive" /><em>Tensorflow <div class="icon baseline"><img src="images/tf.svg"/></div></em></li>
                <li><span className="bar-expand twentyfive" /><em>PyTorch <div class="icon baseline"><img src="images/pytorch.svg"/></div></em></li>
                <li><span className="bar-expand twentyfive" /><em>NodeJS <FontAwesomeIcon icon={faNodeJs} /></em></li>
                <li><span className="bar-expand twentyfive" /><em>React <FontAwesomeIcon icon={faReact} /></em></li>
              </ul>
            </div>{/* end skill-bars */}
          </div> {/* main-col end */}
        </div> {/* End skills */}
      </section> {/* Resume Section End*/}

      </React.Fragment>
    );
  }
}
